import CardContainer from "@/common/cards/CardContainer";
import ListView from "@/common/custom-lists/ListView";
import TableViewList from "@/common/custom-selectors/TableViewList";
import _, { orderBy, sortedIndex } from "lodash";
import { useMemo, useState } from "react";
import { connect } from "react-redux";
import ClientRow from "./ClientRow";
import Select from "react-select";
import { subMonths, addMonths, isWithinInterval } from "date-fns";

const viewOptions = ["Normal", "Card", "Enrolment"].map((value) => ({ label: value, value }));

const statusOptions = [
	{ value: ["Active", "Complimentary"], label: "Active" },
	{ value: "Archived", label: "Archived" },
	{ value: "Suspended", label: "Suspended" },
	{ value: "Setup", label: "Setup" },
];

const AdvisorClients = ({ organisations }) => {
	const storedView = localStorage.getItem("advisor-client-view");
	const [view, setView] = useState(viewOptions.find(({ value }) => value == storedView) || viewOptions[0]);
	const [selectedStatus, setStatus] = useState(null);
	const [sortBy, setSortBy] = useState("name");
	const [sortType, setSortType] = useState("asc");

	const columns = useMemo(() => {
		const columns = [];

		switch (view?.value) {
			case "Normal":
				columns.push(...[{ hidden: true }, "Company", "Status", { hidden: true }]);
				setSortBy("name");
				break;
			case "Card":
				columns.push(...["Clients"]);
				break;
			case "Enrolment":
				columns.push(
					...[
						{ hidden: true },
						"Company",
						"Deadline",
						"Responsible Person",
						//"Notif. Date",
						// "Last Reminder",
						"Status",
						// "Submission Date",
						{ hidden: true },
					],
				);
				setSortBy("nextReassessmentDateDeadline");
				break;
		}
		return columns;
	}, [view?.value]);

	const filteredClients = useMemo(() => {
		const clients = selectedStatus
			? organisations.filter((c) => {
					if (Array.isArray(selectedStatus)) {
						return selectedStatus.includes(c.status);
					} else {
						return c.status === selectedStatus;
					}
				})
			: organisations;

		return _.sortBy(clients, [sortBy], [sortType]);
	}, [organisations, selectedStatus, sortBy, sortType]);

	return (
		<>
			<div className="content bg-gray-lighter">
				<div className="row">
					<div className="col-sm-12">
						<div className="pull-left">
							<h1 className="page-heading">Clients</h1>
						</div>
					</div>
				</div>
			</div>
			<div className="clearfix" />
			<div className="content bg-white">
				<div className="block-header">
					<div className="col-xs-2 pl-0 pull-right">
						<label for="status">Status</label>
						<Select
							options={statusOptions}
							styles={{
								menu: (provided) => ({ ...provided, zIndex: 10 }),
							}}
							onChange={(e) => {
								setStatus(e?.value || null);
							}}
							isClearable
						/>
					</div>
				</div>
				<ListView
					{...{
						title: "Client",
						items:
							view?.value !== "Card"
								? filteredClients?.map((client) => (
										<ClientRow
											key={client.id}
											client={client}
											view={view?.value}
										/>
									))
								: null,
						columns,
						viewList: (
							<div className="pull-right">
								<TableViewList
									options={viewOptions}
									value={view}
									onChange={(option) => {
										setView(option);
										localStorage.setItem("advisor-client-view", option.value);
									}}
								/>
							</div>
						),
					}}
				/>
				{view?.value === "Card" ? (
					<CardContainer>
						{filteredClients?.map((client) => (
							<ClientRow
								key={client.id}
								client={client}
								view={view?.value}
							/>
						))}
					</CardContainer>
				) : null}
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	const advisorCompanies =
		state?.organisations
			?.filter((c) => c.isAdvisor)
			?.map((c) => {
				let statusIndex = 5;

				switch (c.status) {
					case "Suspended":
						statusIndex = 1;
						break;
					case "Setup":
						statusIndex = 2;
						break;
					case "Complimentary":
					case "Active":
						statusIndex = 3;
						break;
				}

				return {
					...c,
					statusIndex,
				};
			}) || [];

	return {
		organisations: orderBy(advisorCompanies, ["statusIndex", "name"], ["asc", "asc"]),
		isAdmin: state.my.profile.isAdmin,
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AdvisorClients);
